import mapProps from '../scripts/utils/map-props';
import ImageViewer from './image-viewer';

export default mapProps(
  [
    'index',
    'visible',
  ],
  {
    model: {
      prop: 'index',
      event: 'change',
    },
  }
)(ImageViewer);
